export enum ChatUserRoleType {
  Agent = "Agent",
  Admin = "Admin"
}
